// Path: ./src/app/pages/SavedProductDealTab/styled.ts
import styled from "styled-components";

export const Wrapper = styled.div`
  margin-bottom: 40px;
`;

export const DealWrapper = styled.div`
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 40px;

  display: flex;
  flex-wrap: wrap;
  padding-left: 24px;
  align-items: center;

  @media (max-width: 810px) {
    justify-content: center;
    padding-left: 0px;
  }
`;

export const Element = styled.div`
  margin-left: 12px;
  margin-top: 12px;
`;
export const PaginationWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
`;
